export default __webpack_public_path__ + "static/media/windows_event_log_monitor.c7e733eb.md";